export default "__VITE_ASSET__DxRLU_JC__"